import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../lib/auth';

export default function Layout() {
  const { logout } = useAuth();

  return (
    <div className="app-shell">
      <header className="topbar">
        <div className="brand">
          <span className="brand-dot" />
          CF Mail Inbox
        </div>
        <nav className="nav">
          <NavLink to="/" end>
            Inbox
          </NavLink>
          <NavLink to="/search">Search</NavLink>
          <NavLink to="/settings">Settings</NavLink>
        </nav>
        <button type="button" className="btn" onClick={logout}>
          退出
        </button>
      </header>
      <main className="main">
        <Outlet />
      </main>
    </div>
  );
}
